import { Graph, Point, EdgeView, ObjectExt } from '@antv/x6';
import { RandomRouterArgs } from './type';

// 边
Graph.registerEdge(
  'mindmap-edge',
  {
    attrs: {
      line: {
        targetMarker: '',
        stroke: '#8EBEED',
        strokeWidth: 2,
      },
    },
    router: (vertices: Point.PointLike[], args: RandomRouterArgs, view: EdgeView) => {
      const { sourceAnchor, targetAnchor } = view;
      if (sourceAnchor.y === targetAnchor.y) {
        return [];
      }
      return [
        { x: (sourceAnchor.x + targetAnchor.x) / 2, y: sourceAnchor.y },
        { x: (sourceAnchor.x + targetAnchor.x) / 2, y: targetAnchor.y },
      ];
    },
    // connector: {
    //     name: 'rounded',
    //     args: {
    //         radius: 10,
    //     },
    // },
  },
  true,
);
